<template>
  <section v-if="days && Object.keys(days).length">
    <div
      v-for="(d, price) in days"
      :key="price"
      class="days"
    >
      <div class="days__block">
        <div class="bid__smalltext">
          Дата погрузки:
        </div>
        <div class="days__block-dates">
          <span v-for="(date, i) in d.dates" :key="i">
            {{ prepareDate(date, i, d.dates.length) }}
          </span>
        </div>
      </div>
      <div class="days__block mod-right">
        <div class="days__block-prices">
          <div class="title bid__smalltext">{{ d.priceType ? d.priceType : 'Цена:' }}</div>
          <div class="price">{{ d.priceText }}</div>
        </div>
        <div v-if="d.priceText2" class="days__block-prices">
          <div v-if="d.priceType2" class="title bid__smalltext"> {{ d.priceType2 }}</div>
          <div class="price">{{ d.priceText2 }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DayInfo',
  props: {
    days: {
      type: Object,
      default: () => {},
    },
    choosed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    prepareDate(date, i = 0, length = 1) {
      const arr = date.split('-')
      const sep = i + 1 < length ? ', ' : ''

      return `${arr[2]}.${arr[1]}${sep}`
    },
  },
}
</script>

